import * as Yup from 'yup';

export const createWebhookSchema = Yup.object().shape({
  description: Yup.string().required('Preencha o campo nome'),
  product_id: Yup.number().required(),
  url: Yup.string().url('Insira uma URL válida, obrigátorio http:// ou https://').required('Preencha o campo URL, obrigátorio http:// ou https://'),
  content_type: Yup.string().required('Selecione um formato da resposta'),
});
